import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPopularCitiesFailed, EGetPopularCitiesActionTypes } from './types';

export const getPopularCitiesFailed: () => TGetPopularCitiesFailed =
  actionGenerator<EGetPopularCitiesActionTypes.Failed>(EGetPopularCitiesActionTypes.Failed);
